import type { User } from '../../models/User';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, auth_id, customer_id, user_type, name, created_at`;

export class UserRepository extends SupabaseRepository<User> {
  constructor(client: SupabaseClient) {
    super('users', selector, client);
  }
}
